module.exports = "/assets/5ffed6593390cd5191089af80f3dded9.svg";